import React from "react";
import { OmniDropdownComponent, OmniIconComponent, Utils } from "../../../../shared";

export default class OrphanedFilterComponent extends React.Component {

    defaultState = {
        filterData: {
            vendor: '',
            channel: [],
            campaign: [],
        },
        enableFilter: false,
        disableApplyButton: true,
        campaignOptions: {
            channel: [],
            campaign: [],
        },
    }

    constructor(props) {
        super(props);
        this.state = {
            ...this.defaultState,
            filterOptions: this.props.filterDropdownOptions,
        }
        this.nodeRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.filterDropdownOptions !== this.props.filterDropdownOptions) {
            this.setState({ filterOptions: this.props.filterDropdownOptions});
        }
    }

    /**
     * Toggle the filter component visibility
     */
    toggleFilter = () => {
        this.setState({ enableFilter: !this.state.enableFilter });
    }

    /**
     * Clear all the filters and close the filter component
     */
    clearAll = () => {
        this.setState({ filterData: this.defaultState.filterData, disableApplyButton: true});
        this.toggleFilter();
        this.props.onApplyFilter();
    }

    /**
     * Handle the data change in the filter component and update the state accordingly
     * @param {String} type
     * @param {Object} event
     * @returns {void}
     */
    onDataChange = (type, event) => {
        let value = Utils.getValue(event);
        const data = { ...this.state.filterData, [type]: type=== 'channel'? [value]:value }
        this.setState({ filterData: data},()=>{
            if(Object.keys(data).every(key => data[key] === '' || !data[key].length)){
                this.setState({ disableApplyButton: true });
            } else{
                this.setState({ disableApplyButton: false });
            }
          })
    }

    /**
     * Apply the filter and close the filter component
     */
    applyFilter = () => {
        const filteredData = {};
        const data = this.state.filterData;

        for(const key in data){
            if(typeof data[key] === 'string' && data[key] !== ''){
                filteredData[key] = data[key];
            } else if(Array.isArray(data[key]) && data[key].length){
                filteredData[key] = data[key];
            }
        }
        this.toggleFilter();
        this.props.onApplyFilter(filteredData);
    }

    render() {
        
        const { enableFilter, filterOptions, filterData, disableApplyButton }  = this.state;
        return (
            <>
                <omni-tooltip>
                    <button slot="invoker" className={`icon ${enableFilter ? 'is-active' : ''}`}
                        onClick={this.toggleFilter}>
                        <OmniIconComponent className="is-size-2" icon-id="omni:interactive:filter" />
                    </button>
                    <span slot="content">Filters</span>
                </omni-tooltip>
                {enableFilter &&
                    <Draggable nodeRef={this.nodeRef} axis="both" bounds='body' defaultPosition={{ x: -185, y: 220 }}>
                        <div ref={this.nodeRef}>
                            <div className="orphaned-filter-container">
                                <div className="orphaned-filter-header">
                                    <span className='filter-title'>Filters</span>
                                </div>
                                <hr className="orphaned-filter-devider" />
                                <div className="orphaned-filter-body">
                                    <button className="clear-all-button" onClick={this.clearAll}>Clear All</button>
                                    <section className="filter-campaign-section flex-column">
                                        <span className="field-text-label">Campaign</span>
                                        <OmniDropdownComponent
                                            typeahead
                                            hidefooter
                                            searchindropdown
                                            placeholder="Select Option"
                                            value={filterData['campaign']?[filterData['campaign']]:[]}
                                            options={filterOptions['campaign']}
                                            className="orphaned-filter-dropdown"
                                            id="orphaned-filter-campaign-dropdown"
                                            onDropdownChange={(event) => this.onDataChange("campaign", event)}
                                        />
                                    </section>
                                    <section className="filter-channel-section flex-column">
                                        <span className="field-text-label">Channel</span>
                                        <OmniDropdownComponent
                                            typeahead
                                            hidefooter
                                            multiselect
                                            searchindropdown
                                            placeholder="Select Option"
                                            value={filterData['channel']}
                                            options={filterOptions['channel']}
                                            className="orphaned-filter-dropdown"
                                            id="orphaned-filter-channel-dropdown"
                                            onDropdownChange={(event) => this.onDataChange("channel", event)}
                                        />
                                    </section>
                                    <section className="filter-Vendor-section flex-column">
                                        <span className="field-text-label">Orphaned delivered object name</span>
                                        <input type="text" placeholder="Orphaned Delivered Object Name" value={filterData['vendor']}
                                             className="input text" onChange={(event) => this.onDataChange("vendor", event)}>
                                        </input>
                                    </section>
                                </div>
                                <div className="orphaned-filter-footer">
                                <button className="tertiary" onClick={this.toggleFilter}>Cancel</button>
                                    <button disabled={disableApplyButton} onClick={this.applyFilter}>Apply</button>
                                </div>
                            </div>
                        </div>
                    </Draggable>
                }
            </>
        )
    }

}